export const loggedInState = (state) => state.auth.isLoggedIn;

export const authUserState = (state) => state.auth.authUser;

export const signupPayloadSelect = (state) => state.auth.signupPayload;
